import React, { Component } from 'react';

class SubmitImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      errors: '',
    };
  }

  handleChange = image => {
    if (image) {
      this.sendImageToDB(image);
      this.setState({ image, errors: '' });
    } else {
      console.log('errors uploading and image');
      this.setState({ errors: 'Files should be less than 5 MB' });
    }
  };

  sendImageToDB = image => {
    const formData = new FormData();
    formData.append(this.props.type, image);

    const config = {
      method: 'PUT',
      headers: {
        'X-User-Email': JSON.parse(localStorage.state).auth.email,
        'X-User-Token': JSON.parse(localStorage.state).auth.token,
      },
      body: formData,
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/users`, config)
      .then(data => data.json())
      .then(response => {
        this.props.refetch();
      })
      .catch(err => {
        console.log('Error submitting image!', err);
      });
  };

  limitSize = fileSize => fileSize <= 20000000;

  render() {
    return (
      <input
        id="edit_photo"
        style={{ display: 'none' }}
        type="file"
        accept="image/jpg, image/jpeg, image/png, image/bmp, image/tif"
        onChange={evt => this.handleChange(evt.target.files[0])}
      />
    );
  }
}

export default SubmitImage;



// WEBPACK FOOTER //
// ./src/components/NewProfile/SubmitImage.js